import React from "react";
import QuoteBox from "./quoteBox";

import "./randomQuoteMachine.css";

const RandomQuoteMachine = () => {
  return (
    <div className="randomQuoteMachine-container">
      <QuoteBox />
    </div>
  );
};

export default RandomQuoteMachine;
